import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ddf6daf")

_pushScopeId("data-v-6ddf6daf")
const _hoisted_1 = { class: "faq-block" }
const _hoisted_2 = { class: "faq-block__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.faqs, (faq) => {
      return (_openBlock(), _createBlock("div", {
        key: faq.id,
        class: ["faq-block__item", { active: $setup.state[faq.id] }]
      }, [
        _createVNode("div", {
          class: "faq-block__header",
          onClick: $event => ($setup.state[faq.id] = !$setup.state[faq.id])
        }, [
          _createVNode("span", null, _toDisplayString(faq.title), 1),
          _createVNode(_component_svg_icon, { name: "arrowdown2-brown" })
        ], 8, ["onClick"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            innerHTML: faq.content
          }, null, 8, ["innerHTML"])
        ])
      ], 2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})